import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";

export default function BrandHeader({ small = false, right = null }) {
  return (
    <header className="w-full px-6 md:px-12 py-5 flex items-center justify-between"
            data-testid="brand-header">
      <Link to="/" className="flex items-center gap-3 group" data-testid="brand-home-link">
        <BrandLogo size={small ? "sm" : "md"} className="transition-transform group-hover:scale-105" />
        <div className="leading-none">
          <div className="label-eyebrow">HER Aligned</div>
          {!small && (
            <div className="font-serif text-xl text-brand-ink mt-1">
              Your Personal Roadmap
            </div>
          )}
        </div>
      </Link>
      <div>{right}</div>
    </header>
  );
}
